export default __webpack_public_path__ + "static/media/slime-bnb.74ad3c69.png";